import { useTranslation } from '@pancakeswap/localization'
import { Flex } from '@pancakeswap/uikit'
import ArrowDashDown from '@pancakeswap/uikit/components/Svg/Icons/ArrowDashDown'
import ArrowDashUp from '@pancakeswap/uikit/components/Svg/Icons/ArrowDashUp'
import EyeIcon from '@pancakeswap/uikit/components/Svg/Icons/EyeIcon'
import WordmarkIcon from '@pancakeswap/uikit/components/Svg/Icons/WordmarkIcon'
import styled from 'styled-components'
import { Touchable } from 'views/Layout/styled'
import {
  WalletCardActions,
  WalletCardAmount,
  WalletCardButton,
  WalletCardButtonText,
  WalletCardTitle,
  WalletCardTop,
} from '../styled'

const Wrapper = styled.div`
  display: flex;
  width: 270px;
  height: 150px !important;
  margin-left: -9px;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 13.753px;
  border: 0.86px solid #f59c53;
  background: rgba(245, 156, 83, 0.2);
  backdrop-filter: blur(0.6386253833770752px);
  gap: 45px;

  @media (max-width: 768px) {
    display: none;
  }
`

const WalletCard = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <WalletCardTop>
        <Flex style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
          <WalletCardTitle>Your Valut</WalletCardTitle>
          <Flex style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}>
            <WalletCardAmount>$2498.01</WalletCardAmount>
            <Touchable>
              <EyeIcon />
            </Touchable>
          </Flex>
        </Flex>
        <WordmarkIcon />
      </WalletCardTop>
      <WalletCardActions>
        <WalletCardButton>
          <ArrowDashUp />
          <WalletCardButtonText>{t('Send & Withdraw')}</WalletCardButtonText>
        </WalletCardButton>
        <WalletCardButton>
          <ArrowDashDown />
          <WalletCardButtonText>{t('Receive & Fund')}</WalletCardButtonText>
        </WalletCardButton>
      </WalletCardActions>
    </Wrapper>
  )
}

export default WalletCard
